// 9fbef606107a605d69c0edbcd8029e5d
import { BIRTHDAY_PRODUCT_LISTING___ACTION_PATTERN } from '@tcp/core/src/constants/reducer.constants';

const CONSTANTS = {
  OPEN_BIRTHDAY_RECOMMANDATION_DRAWER: `${BIRTHDAY_PRODUCT_LISTING___ACTION_PATTERN}OPEN_BIRTHDAY_RECOMMANDATION_DRAWER`,
  SET_CHILDREN: `${BIRTHDAY_PRODUCT_LISTING___ACTION_PATTERN}SET_CHILDREN`,
  FETCH_BIRTHDAY_RECOMMANDTIONS: `${BIRTHDAY_PRODUCT_LISTING___ACTION_PATTERN}FETCH_BIRTHDAY_RECOMMANDTIONS`,
};

export default CONSTANTS;
